import React from "react";
import BackImg from "@assets/images/stepsBack.jpg";
import { Avatar } from "@mui/material";
import { useNavigate } from "react-router-dom";
import NotFound from "@components/ui/NotFound";
import {
  YellowRanks,
  GreenRank,
  GrayRank,
  BrownRanks,
} from "@utils/defaultImages";
import NoHistory from "@features/mindfulness/NoHistory";
import { useTranslation } from "react-i18next";
const TopPlayers = ({ progressTracker = false, topPlayers = [] }) => {
  const Ranks = [<YellowRanks />, <GrayRank />, <BrownRanks />, <GreenRank />];
  const navigate = useNavigate();
  const {t} = useTranslation();
  return (
    <div
      className="p-6 rounded-lg bg-cover from-blue-600 to-blue-500 h-full"
      style={{ backgroundImage: `url(${BackImg})` }}
    >
      <div className="flex justify-between items-center mb-2">
        <h4 className="text-[16px] font-[Lato] text-white">
          {t("quizGame.Top Players this week")}
        </h4>
        <button
          className="bg-white rounded-md text-[#0575e6] text-[12px] font-[Lato] py-2 px-3"
          onClick={() =>
            navigate(
              progressTracker
                ? "/progress-tracker/weekly-Leader-board"
                : "/quiz-game/weekly-Leader-board"
            )
          }
        >
          {t("quizGame.View All")}
        </button>
      </div>

      {/* Custom scrollable container */}
      <div className="space-y-2 max-h-[340px] overflow-y-auto pr-2 custom-scrollbar">
        {topPlayers?.length > 0 ? (
          <div className="bg-white rounded-2xl p-4 grid grid-cols-10 justify-between space-y-2">
            <div className="col-span-6"></div>
            <div className="text-[12px] text-[#767676] font-[Lato] col-span-2 text-center">
              {t("quizGame.Points")}
            </div>
            <div className="text-[12px] text-[#767676] font-[Lato] col-span-2 text-center">
              {t("quizGame.Ranks")}
            </div>

            <div className="grid grid-cols-10 col-span-10 space-y-4">
              {topPlayers?.map((item, index) => (
                <>
                  <p
                    disabled
                    className="text-[14px] font-[Lato] flex items-center col-span-6 flex gap-1"
                  >
                    <span>{index + 1}.</span>{" "}
                    {item?.profile_url ? (
                      <img
                        src={item?.profile_url}
                        alt="User"
                        className="!w-6 !h-6 rounded-full object-cover"
                      />
                    ) : (
                      <span>
                        <Avatar className="!w-6 !h-6" />
                      </span>
                    )}{" "}
                    <span>{item?.name}</span>
                  </p>

                  <p className="text-[14px] font-[Lato] font-[400] font-normal col-span-2 text-center">
                    {item?.points}
                  </p>
                  <div className="col-span-2 flex justify-center">
                    {/* <svg
                    width="18"
                    height="25"
                    viewBox="0 0 18 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.7876 0H2.21244C1.01607 0 0 1.00379 0 2.30161V23.1837C0.00352052 24.831 1.93755 25.6039 3.03708 24.4476L8.21154 19.0661C8.62621 18.6161 9.37379 18.6161 9.78846 19.0661L14.9629 24.4476C16.0629 25.6043 17.9967 24.8302 18 23.1837V2.30161C18 1.00379 16.9839 0 15.7876 0Z"
                      fill="#FFB31C"
                    />
                    <path
                      d="M11.5655 14.048V15H6.18945V14.048H8.33845V7.209C8.33845 7.00367 8.34545 6.796 8.35945 6.586L6.57445 8.119C6.51379 8.17033 6.45312 8.203 6.39245 8.217C6.33179 8.22633 6.27579 8.22633 6.22445 8.217C6.17312 8.20767 6.12412 8.189 6.07745 8.161C6.03545 8.133 6.00279 8.10267 5.97945 8.07L5.58745 7.531L8.57645 4.948H9.59145V14.048H11.5655Z"
                      fill="white"
                    />
                  </svg> */}
                    <div className="relative">
                      {Ranks[Math.min(index, 3)]}
                      <div className="absolute top-2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[14px] font-[Lato] text-white">
                        {item?.rank}
                      </div>
                    </div>
                  </div>
                </>
              ))}
            </div>
          </div>
        ) : (
          <div className="text-white text-center py-4">
            <NoHistory topPlayers={true} />
          </div>
        )}
      </div>

      <style jsx>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 12px;
        }

        .custom-scrollbar::-webkit-scrollbar-track {
          background-color: #fff !important;
          border-radius: 10px;
          margin: 4px 0;
        }

        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: linear-gradient(150deg, #0771ef 12.89%, #15aafc 85.22%);
          border-radius: 10px;
          border: 1px solid rgba(255, 255, 255, 0.2);
          box-shadow: inset 0 1px 2px rgba(255, 255, 255, 0.3);
        }
      `}</style>
    </div>
  );
};

export default TopPlayers;
